import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getWarningRuleList(data) {
  return request({
    url: URL.warnRule.getWarningRuleList,
    method: 'post',
    data
  })
}

export function getWarningConfig(params) {
  return request({
    url: URL.warnRule.getWarningConfig,
    method: 'get',
    params
  })
}
// 获取sop 预警配置
export function querySOPConfig(data) {
  return request({
    url: URL.warnRule.querySOPConfig,
    method: 'post',
    data
  })
}
// 删除预警
export function delWarningRule(params) {
  return request({
    url: URL.warnRule.delWarningRule,
    method: 'get',
    params
  })
}
// 删除预警
export function closeByBatchIds(params) {
  return request({
    url: URL.warnRule.closeByBatchIds,
    method: 'get',
    params
  })
}

// 修改预警
export function saveWarningRule(data) {
  return request({
    url: URL.warnRule.saveWarningRule,
    method: 'post',
    data
  })
}
// 校验数据服务保存配置
export function checkDataServiceSave(data) {
  return request({
    url: URL.warnRule.checkDataServiceSave,
    method: 'post',
    data
  })
}

// 修改预警
export function saveWarningConfig(data) {
  return request({
    url: URL.warnRule.saveWarningConfig,
    method: 'post',
    data
  })
}
